var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5303 15.5303C18.8232 15.2374 18.8232 14.7626 18.5303 14.4697L12.5303 8.46967C12.2374 8.17678 11.7626 8.17678 11.4697 8.46967L5.46967 14.4697C5.17678 14.7626 5.17678 15.2374 5.46967 15.5303C5.76256 15.8232 6.23744 15.8232 6.53033 15.5303L12 10.0607L17.4697 15.5303C17.7626 15.8232 18.2374 15.8232 18.5303 15.5303Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTop);
export default __webpack_public_path__ + "static/media/Arrow-top.02cc9730dbae9a451c10b9ff79e330d1.svg";
export { ForwardRef as ReactComponent };